import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createExtensionSuccess } from 'src/app/pages/add-extension/state/add-extension.actions';
import { saveExtensionDetailSuccess } from 'src/app/pages/extension-details/state/extension-detail.actions';
import { PhoneOption } from 'src/app/pages/phones/models/phone-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterPhoneOption } from '../../select/shared/filter-phone-option';
import { phoneOptionActions } from './phone-option.actions';

export const phoneOptionFeatureKey = 'phoneOptions';

export type PhoneOptionState = EagerSelectState<PhoneOption>;

const adapter = createEagerSelectAdapter<PhoneOptionState, PhoneOption>({
   featureKey: phoneOptionFeatureKey,
   selectId: (phone: PhoneOption) => {
      return phone.phoneId;
   },
});

export const phoneOptionSelectors = adapter.getSelectors(filterPhoneOption);

const initialState = adapter.getInitialState();

export const phoneOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   phoneOptionActions.search,
   phoneOptionActions.searchReset,
   phoneOptionActions.loadFromApi,
   phoneOptionActions.loadFromApiSuccess,
   phoneOptionActions.loadFromApiFailure,
   null,
   on(createExtensionSuccess, saveExtensionDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
